import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  MerchantTypeListReq,
  MerchantTypeListRes,
  CreateMerchantTypeReq,
  ActionMerchantTypeRes,
  DeleteMerchantTypeReq,
  UpdateMerchantTypeReq,
} from './types'

export const getMerchantTypeListAction = createAsyncAction(
  'MERCHANT_TYPE/GET_MERCHANT_TYPE_LIST_REQ',
  'MERCHANT_TYPE/GET_MERCHANT_TYPE_LIST_SUCCESS',
  'MERCHANT_TYPE/GET_MERCHANT_TYPE_LIST_FAILURE',
)<MerchantTypeListReq, MerchantTypeListRes, Error>()

export const createMerchantTypeAction = createAsyncAction(
  'MERCHANT_TYPE/CREATE_MERCHANT_TYPE_REQ',
  'MERCHANT_TYPE/CREATE_MERCHANT_TYPE_SUCCESS',
  'MERCHANT_TYPE/CREATE_MERCHANT_TYPE_FAILURE',
)<CreateMerchantTypeReq, ActionMerchantTypeRes, Error>()

export const updateMerchantTypeAction = createAsyncAction(
  'MERCHANT_TYPE/UPDATE_MERCHANT_TYPE_REQ',
  'MERCHANT_TYPE/UPDATE_MERCHANT_TYPE_SUCCESS',
  'MERCHANT_TYPE/UPDATE_MERCHANT_TYPE_FAILURE',
)<UpdateMerchantTypeReq, ActionMerchantTypeRes, Error>()

export const deleteMerchantTypeAction = createAsyncAction(
  'MERCHANT_TYPE/DELETE_MERCHANT_TYPE_REQ',
  'MERCHANT_TYPE/DELETE_MERCHANT_TYPE_SUCCESS',
  'MERCHANT_TYPE/DELETE_MERCHANT_TYPE_FAILURE',
)<DeleteMerchantTypeReq, ActionMerchantTypeRes, Error>()

export const clearEventAction = createStandardAction('MERCHANT_TYPE/CLEAR_EVENT')<void>()
